/**
 * Report Studio - Templates page.
 * Browses available templates for creating new reports.
 */

import { createFileRoute } from '@tanstack/react-router';

import { ReportStudioShell, TemplateList } from '@/features/analytics/report-studio';
import i18n from '@/lib/i18n';

export const Route = createFileRoute(
  '/_authenticated/analytics/report-studio/templates'
)({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.reportStudioTemplates'),
  }),
  component: ReportStudioTemplatesPage,
});

function ReportStudioTemplatesPage() {
  return (
    <ReportStudioShell>
      <TemplateList />
    </ReportStudioShell>
  );
}
